import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import { AiCopilotDrawer } from '../../../components/ai-copilot/AiCopilotDrawer';
import { AiCopilotProvider } from '../../../components/ai-copilot/context/AiCopilotProvider';
import { useAiCopilot } from '../../../components/ai-copilot/context/use-ai-copilot';
import { VyLayout } from '../../../components/new-design/layout/VyLayout';
import { withGlobalSearchParams } from '../../../components/utility/GlobalSearchParamsBoundary';
import { withSuspenseBoundary } from '../../../components/utility/SuspenseBoundary';
import { USAGE_DATA_REPORT_CONTEXT, USAGE_DATA_REPORT_SUGGESTIONS } from '../usage-data-report-suggestions';
import { AnonymousCustomersReportContent } from './anonymous-customers-report-components/AnonymousCustomersReportContent';

const AnonymousCustomersReportLayout: React.FC<{ reportId?: string }> = ({ reportId }) => {
  const { isOpen, drawerWidth } = useAiCopilot();

  return (
    <>
      <Box
        sx={{
          transition: (theme) =>
            theme.transitions.create('margin-right', {
              easing: isOpen
                ? theme.transitions.easing.easeOut
                : theme.transitions.easing.sharp,
              duration: isOpen
                ? theme.transitions.duration.enteringScreen
                : theme.transitions.duration.leavingScreen,
            }),
          marginRight: isOpen ? `${drawerWidth}px` : 0,
        }}
      >
        <VyLayout>
          <AnonymousCustomersReportContent reportId={reportId} />
        </VyLayout>
      </Box>
      <AiCopilotDrawer />
    </>
  );
};

const AnonymousCustomersReportPage = () => {
  const { reportId } = useParams();

  return (
    <AiCopilotProvider suggestions={USAGE_DATA_REPORT_SUGGESTIONS} reportContext={USAGE_DATA_REPORT_CONTEXT}>
      <Helmet>
        <title>Report</title>
      </Helmet>
      <AnonymousCustomersReportLayout reportId={reportId} />
    </AiCopilotProvider>
  );
};

const AnonymousCustomersReportPageWithSuspenseBoundary = withSuspenseBoundary(
  withGlobalSearchParams(AnonymousCustomersReportPage),
);
export { AnonymousCustomersReportPageWithSuspenseBoundary as AnonymousCustomersReportPage };
